import * as React from 'react';
import { IServerUserInfo } from '../../ts/models/IServerUserInfo';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import { SavedCredentialsForDataSourceSetting } from './SavedCredentialsForDataSourceSetting';
import { Messages } from '../../codegen/Localize';
import { UserSettingsHelper } from '../UserSettingsHelper';
import { ConnectedDevices } from './ConnectedClientsSection';

export interface SecuritySettingsProps {
  //meta data realted to business logic
  serverUser: IServerUserInfo;
  isViewerSelf: boolean;
  isServerUserSubplace: boolean;
}

export function SecuritySettings(props: SecuritySettingsProps) {
  return (
    <>
    <h2 className={UserSettingsStyle.titleText}>{Messages.userSettings_Security_Header()}</h2>
    <table>
      <tbody>
        {props.isViewerSelf && !props.isServerUserSubplace && <tr>
          <td className={UserSettingsStyle.tbodyNew} colSpan={3}>
            <SavedCredentialsForDataSourceSetting serverUser={props.serverUser} />
          </td>
        </tr>}
        {props.isViewerSelf && !props.isServerUserSubplace && UserSettingsHelper.getSectionDividerLine()}
        <tr>
          <td className={UserSettingsStyle.tbodyNew} colSpan={3}>
            <ConnectedDevices serverUser={props.serverUser} />
          </td>
        </tr>
      </tbody>
    </table>
    </>
  );
}